const BASE_URL = import.meta.env.VITE_APP_API_URL;

// Export as default (ES module syntax)
export default Object.freeze({
  SIGN_UP_URL: BASE_URL + "/public/api/v1/auth/signUp",
  SIGN_IN_URL: BASE_URL + "/public/api/v1/auth/signIn",
  GET_PROFILE_URL: BASE_URL + "/public/api/v1/auth/getprofile/",
  AUTH_URL: BASE_URL + "/public/api/v1/auth/",
  VERIFY_ACCOUNT: BASE_URL + "/public/api/v1/auth/verifyAccount",
});
